import { SystemAuthorizations } from 'shell/authorizations/system';
import { HeadCell } from 'shell/components/shared/table/types';
import * as yup from 'yup';
import { TypeSubscriberClient } from './types';

export const authsObj = Object.freeze({
  read: [SystemAuthorizations.SottoscrittoreAdd],
  create: [SystemAuthorizations.SottoscrittoreDelete],
  edit: [SystemAuthorizations.SottoscrittoreQuery],
  delete: [SystemAuthorizations.SottoscrittoreUpdate],
});

export const validationSchemaSubscriberFilterForm = yup.object({
  code: yup.string().nullable().notRequired(),
  description: yup.string().nullable().notRequired(),
});

export const headCells: HeadCell<TypeSubscriberClient, keyof TypeSubscriberClient>[] = [
  {
    id: 'code',
    label: 'Codice',
  },
  {
    id: 'description',
    label: 'Descrizione',
  },
  {
    id: 'action',
    label: '',
  },
];
